import { useEffect, useState } from "react";
import { NavContainer, NavItem, NavMenu, SidebarContainer } from "./style";
import { Sidenav, Modal } from "rsuite";
import "rsuite/dist/rsuite.css";
import { useAppDispatch, useAppSelector } from "../../../Redux/app/hooks";
import { selectNav, closeSidebar } from "../../../Redux/features/navSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { NavItems } from "./Utils";
import { selectUser } from "../../../Redux/features/userSlice";
import { resetHostelParams } from "../../../Redux/features/hostelSlice";
import { selectUtil } from "../../../Redux/features/utilsSlice";
import UnderlinedSelector from "../../../Components/Form/Dropdowns/UnderlinedSelector";
import SmallButton from "../../../Components/Form/Buttons/SmallButton";
import api from "../../../Apis/baseUri";
import { toast } from "react-toastify";

const Sidebar = () => {
  // const [expanded, setExpanded] = useState(true);
  const [activeKey, setActiveKey] = useState("1");
  const { showSidebar } = useAppSelector(selectNav);
  const { currentUser } = useAppSelector(selectUser);
  const { sessions } = useAppSelector(selectUtil);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();

  const [openUploadTellerModal, setOpenUploadTellerModal] = useState(false);
  const [selectedSessionId, setSelectedSessionId] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  const handlePayOfflineFee = async () => {
    if (!selectedSessionId) {
      toast.error("Please select a session");
      return;
    }
    setLoading(true);
    try {
      const response = await api.get("/Payments/OfflineFee", {
        params: { sessionId: selectedSessionId }
      });
      const link = response?.data?.etransact?.paymentUrl || response?.data?.paymentUrl || (typeof response?.data === 'string' ? response?.data : null);
      if (link) {
        toast.success("Redirecting to payment gateway...");
        window.open(link, "_blank");
        setOpenUploadTellerModal(false);
      } else {
        toast.error("Failed to retrieve payment link. Please try again.");
      }
    } catch (err: any) {
      if (err?.response?.data) {
        toast.error(err?.response?.data);
      } else {
        toast.error("An error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    pathname === `/` && setActiveKey("1");
    pathname.includes(`/admission/admission-letter`) && setActiveKey("2-1");
    pathname.includes(`/admission/acknowledgement-slip`) && setActiveKey("2-2");
    pathname === `/clearance` && setActiveKey("3");
    pathname === `/result` && setActiveKey("4");
    pathname === `/course-registration` && setActiveKey("5");
    pathname === `/hostel` && setActiveKey("6");
    pathname === `/hostel/hostel-booking` && setActiveKey("6-1");
    pathname === `/hostel/hostel-history` && setActiveKey("6-2");
    pathname === `/hostel/print-hostel-card` && setActiveKey("6-2");
    pathname === `/hostel/hostel-active-block-room` && setActiveKey("6-3");
    pathname === `/account` && setActiveKey("7");
    pathname === `/change-password` && setActiveKey("7");
    pathname === `/payment/payment-history` && setActiveKey("8-1");
    pathname === `/payment/view-payment-history` && setActiveKey("8-1");
    pathname === `/payment/generate-invoice` && setActiveKey("8-2");
    pathname === `/payment/view-generated-invoice` && setActiveKey("8-2");
  }, [pathname]);

  const sessionOptions = sessions
    ? sessions.map((x: any) => ({
        label: x?.sessionName,
        value: x?.sessionId,
      }))
    : [];

  return (
    <SidebarContainer showSidebar={showSidebar}>
      <Sidenav
        defaultOpenKeys={["2", "6", "8"]}
        style={{
          height: `100%`,
          overflowY: `auto`,
          background: `none`,
          position: "relative",
        }}
      >
        <Sidenav.Body>
          <NavContainer
            activeKey={activeKey}
            onSelect={setActiveKey}
            appearance="tabs"
          >
            {currentUser?.roleId === 10 &&
              NavItems?.map((nav: any) => (
                <>
                  {nav?.hasChildren ? (
                    <NavMenu
                      placement="rightStart"
                      eventKey={nav?.id}
                      title={nav?.parentName}
                      style={{ background: `none` }}
                      // icon={nav?.icon}
                    >
                      {nav?.Children?.map((childNav: any) => (
                        <NavItem
                          eventKey={childNav?.id}
                          icon={childNav?.icon}
                          onClick={() => {
                            if (childNav?.childName === "Upload Teller") {
                              dispatch(closeSidebar());
                              setSelectedSessionId(null);
                              setOpenUploadTellerModal(true);
                            } else if (childNav?.isExternal) {
                              window.location.href = `https://verify.gouni.edu.ng/api/auth/sso?accessToken=${currentUser?.accessToken}&target=${childNav?.target}`;
                            } else {
                              navigate(`${childNav?.childLink}`);
                              dispatch(resetHostelParams());
                            }
                          }}
                        >
                          {childNav?.childName}
                        </NavItem>
                      ))}
                    </NavMenu>
                  ) : (
                    <NavItem
                      eventKey={nav?.id}
                      icon={nav?.icon}
                      onClick={() => {
                        if (nav?.parentLink === "/clearance") {
                          window.location.href = `https://verify.gouni.edu.ng/api/auth/sso?accessToken=${currentUser?.accessToken}&target=clearance`;
                        } else {
                          navigate(`${nav?.parentLink}`);
                          dispatch(resetHostelParams());
                        }
                      }}
                    >
                      {nav?.parentName}
                    </NavItem>
                  )}
                </>
              ))}
          </NavContainer>
        </Sidenav.Body>
        {/* <Sidenav.Toggle expanded={expanded} onToggle={(expanded) => setExpanded(expanded)} style={{position: "static", bottom:"30px", width: "100%",}}/> */}
      </Sidenav>
      <Modal open={openUploadTellerModal} onClose={() => setOpenUploadTellerModal(false)} size="xs">
        <Modal.Header>
          <Modal.Title style={{ color: "var(--clr-primary-900)", fontWeight: "bold" }}>Upload Teller Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div>
            <p style={{ marginBottom: "10px", fontSize: "14px", color: "var(--clr-grey-500)" }}>
              select session you want to upload it's payment
            </p>
            <UnderlinedSelector
              dropdownItems={sessionOptions}
              title="Select Session"
              handleDropdownSelect={(_name: any, val: any) => setSelectedSessionId(val)}
              name="sessionId"
              value={selectedSessionId}
            />
          </div>
          <div style={{ marginTop: "10px", fontSize: "14px", fontWeight: "500", color: "#333" }}>
            Pay Offline Upload Teller charges
          </div>
        </Modal.Body>
        <Modal.Footer style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <SmallButton
            buttonText="Proceed"
            handleClick={handlePayOfflineFee}
            loading={loading}
            disabled={!selectedSessionId}
          />
          <SmallButton
            buttonText="Cancel"
            handleClick={() => setOpenUploadTellerModal(false)}
            customStyle={{ background: "#ccc", color: "#333" }}
          />
        </Modal.Footer>
      </Modal>
    </SidebarContainer>
  );
};

export default Sidebar;
